export const AGENT_SEARCH_PARAM = "agent";
export const AGENT_PROJECT_ID_SEARCH_PARAM = "projectId";
export const AGENT_TASK_ID_SEARCH_PARAM = "taskId";
export const AGENT_GOAL_ID_SEARCH_PARAM = "goalId";
export const AGENT_INFORMATION_ITEM_ID_SEARCH_PARAM = "informationItemId";
export const AGENT_TASK_PROJECT_ID_SEARCH_PARAM = "taskProjectId";
export const AGENT_TASK_STATUS_SEARCH_PARAM = "taskStatus";
export const AGENT_TASK_SEARCH_QUERY_SEARCH_PARAM = "taskSearch";
export const AGENT_TASK_VIEW_SEARCH_PARAM = "taskView";
export const AGENT_PROJECT_STATUS_SEARCH_PARAM = "projectStatus";
export const AGENT_PROJECT_SEARCH_QUERY_SEARCH_PARAM = "projectSearch";
export const AGENT_PROJECT_SORT_SEARCH_PARAM = "projectSort";
export const AGENT_SKILL_IMPORT_SEARCH_PARAM = "skillImport";
export const AGENT_ROUTINE_IMPORT_SEARCH_PARAM = "routineImport";
export const AGENT_ROUTINE_STATUS_SEARCH_PARAM = "routineStatus";
export const AGENT_ROUTINE_SEARCH_QUERY_SEARCH_PARAM = "routineSearch";
export const AGENT_ROUTINE_SORT_SEARCH_PARAM = "routineSort";
export const AGENT_ACTIVITY_PROJECT_ID_SEARCH_PARAM = "activityProjectId";
export const AGENT_ACTIVITY_TASK_ID_SEARCH_PARAM = "activityTaskId";
export const AGENT_ACTIVITY_ROUTINE_ID_SEARCH_PARAM = "activityRoutineId";
export const AGENT_ACTIVITY_ENTITY_SEARCH_PARAM = "activityEntity";
export const AGENT_ACTIVITY_SEARCH_QUERY_SEARCH_PARAM = "activitySearch";

export const AGENT_IDENTITY_SEARCH_PARAMS = [
  AGENT_SEARCH_PARAM,
  AGENT_PROJECT_ID_SEARCH_PARAM,
  AGENT_TASK_ID_SEARCH_PARAM,
  AGENT_GOAL_ID_SEARCH_PARAM,
  AGENT_INFORMATION_ITEM_ID_SEARCH_PARAM,
] as const;

/**
 * Every filter param owned by an agent surface. These are stripped when the
 * overlay closes so filter state never leaks onto the underlying route.
 */
export const AGENT_FILTER_SEARCH_PARAMS = [
  AGENT_SKILL_IMPORT_SEARCH_PARAM,
  AGENT_ROUTINE_IMPORT_SEARCH_PARAM,
  AGENT_TASK_PROJECT_ID_SEARCH_PARAM,
  AGENT_TASK_STATUS_SEARCH_PARAM,
  AGENT_TASK_SEARCH_QUERY_SEARCH_PARAM,
  AGENT_TASK_VIEW_SEARCH_PARAM,
  AGENT_PROJECT_STATUS_SEARCH_PARAM,
  AGENT_PROJECT_SEARCH_QUERY_SEARCH_PARAM,
  AGENT_PROJECT_SORT_SEARCH_PARAM,
  AGENT_ROUTINE_STATUS_SEARCH_PARAM,
  AGENT_ROUTINE_SEARCH_QUERY_SEARCH_PARAM,
  AGENT_ROUTINE_SORT_SEARCH_PARAM,
  AGENT_ACTIVITY_PROJECT_ID_SEARCH_PARAM,
  AGENT_ACTIVITY_TASK_ID_SEARCH_PARAM,
  AGENT_ACTIVITY_ROUTINE_ID_SEARCH_PARAM,
  AGENT_ACTIVITY_ENTITY_SEARCH_PARAM,
  AGENT_ACTIVITY_SEARCH_QUERY_SEARCH_PARAM,
] as const;

export const AGENT_SEARCH_PARAMS = [
  ...AGENT_IDENTITY_SEARCH_PARAMS,
  ...AGENT_FILTER_SEARCH_PARAMS,
] as const;

export enum AgentSurfaceId {
  Overview = "overview",
  Goals = "goals",
  Goal = "goal",
  Projects = "projects",
  Project = "project",
  ProjectTasks = "project-tasks",
  Tasks = "tasks",
  Task = "task",
  Information = "information",
  InformationItem = "information-item",
  Routines = "routines",
  Memory = "memory",
  Skills = "skills",
  Activities = "activities",
}

export type AgentOverlayState =
  | { surfaceId: AgentSurfaceId.Overview }
  | { surfaceId: AgentSurfaceId.Goals }
  | { surfaceId: AgentSurfaceId.Goal; goalId: string }
  | { surfaceId: AgentSurfaceId.Projects }
  | { surfaceId: AgentSurfaceId.Project; projectId: string }
  | { surfaceId: AgentSurfaceId.ProjectTasks; projectId: string }
  | { surfaceId: AgentSurfaceId.Tasks }
  | { surfaceId: AgentSurfaceId.Task; taskId: string }
  | { surfaceId: AgentSurfaceId.Information }
  | { surfaceId: AgentSurfaceId.InformationItem; informationItemId: string }
  | { surfaceId: AgentSurfaceId.Routines }
  | { surfaceId: AgentSurfaceId.Memory }
  | { surfaceId: AgentSurfaceId.Skills }
  | { surfaceId: AgentSurfaceId.Activities };

export type AgentEntityRouteParamName =
  | "projectId"
  | "taskId"
  | "skillImportId"
  | "verificationToken";

export type AgentActivityContext =
  | { kind: "project"; projectId: string }
  | { kind: "task"; taskId: string }
  | { kind: "routine"; routineId: string };
